import React from "react";
import styled from "styled-components";

import DateDropdown from "./DateDropdown";
import UIDropdown from "components/UI/Dropdown";
import UILabel from "components/UI/Label";
import UITable from "components/UI/Table";
import UIPagination from "components/UI/Pagination";
import commonStyles from "css/common.module.css";

const groupByOptions = [
  { value: "DATES", text: "Dates" },
  { value: "STATE", text: "State" },
  { value: "FEE_TYPE", text: "Fee Type" },
  { value: "USER", text: "User" },
  { value: "CLIENT", text: "Client" },
  { value: "CLIENT_BRANCH", text: "Client Branch" }
];

const stateOptions = [
  { value: "Alabama", text: "Alabama" },
  { value: "Alaska", text: "Alaska" },
  { value: "Arizona", text: "Arizona" },
  { value: "Arkansas", text: "Arkansas" },
  { value: "California", text: "California" },
  { value: "Colorado", text: "Colorado" },
  { value: "Connecticut", text: "Connecticut" },
  { value: "Delaware", text: "Delaware" }
];

const clientOptions = [
  { value: "Client 1", text: "Client 1" },
  { value: "Client 2", text: "Client 2" },
  { value: "Client 3", text: "Client 3" },
  { value: "Client 4", text: "Client 4" }
];

const feeTypeOptions = [
  { value: "Registration", text: "Registration" },
  { value: "Title", text: "Title" },
  { value: "Plate", text: "Plate" },
  { value: "Other", text: "Other" }
];

const userOptions = [
  { value: "A", text: "A" },
  { value: "B", text: "B" },
  { value: "C", text: "C" },
  { value: "D", text: "D" },
  { value: "E", text: "E" }
];

const branchOptions = [
  { value: "Westlake", text: "Westlake" },
  { value: "Las Colinas", text: "Las Colinas" },
  { value: "Dallas", text: "Dallas" },
  { value: "Fort Worth", text: "Fort Worth" },
  { value: "Arlington", text: "Arlington" }
];

const Container = styled.div.attrs({ className: "analytics-reporting" })`
  & .row {
    margin: 0 0 24px;
    width: 100%;
  }
  & .control {
    display: inline-block;
    margin: 0 24px 0 0;
    width: calc(25% - 24px);
  }
`;

const getRow = () => (
  <UITable.Row>
    <UITable.Cell>January</UITable.Cell>
    <UITable.Cell>Texas</UITable.Cell>
    <UITable.Cell>Registration</UITable.Cell>
    <UITable.Cell>300</UITable.Cell>
    <UITable.Cell>Westlake</UITable.Cell>
    <UITable.Cell>$14,000.00</UITable.Cell>
    <UITable.Cell>$0.00</UITable.Cell>
    <UITable.Cell>$0.00</UITable.Cell>
    <UITable.Cell>$0.00</UITable.Cell>
    <UITable.Cell>$14,000.00</UITable.Cell>
  </UITable.Row>
);

const AnalyticsReporting = () => {
  return (
    <Container
      className={`${commonStyles.page} ${commonStyles.padded} ${
        commonStyles.clear
      }`}
    >
      <div className="row">
        <div className="control">
          <UILabel>Dates:</UILabel>
          <DateDropdown />
        </div>
        <div className="control">
          <UILabel>Group by:</UILabel>
          <UIDropdown multiple options={groupByOptions} />
        </div>
      </div>

      <div className="row">
        {/* <div className="h6">Filters</div> */}
        <div className="control">
          <UILabel>State:</UILabel>
          <UIDropdown multiple options={stateOptions} />
        </div>
        <div className="control">
          <UILabel>Client:</UILabel>
          <UIDropdown multiple options={clientOptions} />
        </div>
        <div className="control">
          <UILabel>Fee Type:</UILabel>
          <UIDropdown multiple options={feeTypeOptions} />
        </div>
        <div className="control">
          <UILabel>User:</UILabel>
          <UIDropdown multiple options={userOptions} />
        </div>
      </div>
      <div className="row">
        <div className="control">
          <UILabel>Branch:</UILabel>
          <UIDropdown multiple options={branchOptions} />
        </div>
      </div>

      <UITable>
        <UITable.Header>
          <UITable.Row>
            <UITable.HeaderCell>Date</UITable.HeaderCell>
            <UITable.HeaderCell>State</UITable.HeaderCell>
            <UITable.HeaderCell>Fee Type</UITable.HeaderCell>
            <UITable.HeaderCell># of Reports</UITable.HeaderCell>
            <UITable.HeaderCell>Branch</UITable.HeaderCell>
            <UITable.HeaderCell>Registration $$</UITable.HeaderCell>
            <UITable.HeaderCell>Title $$</UITable.HeaderCell>
            <UITable.HeaderCell>Plate $$</UITable.HeaderCell>
            <UITable.HeaderCell>Other $$</UITable.HeaderCell>
            <UITable.HeaderCell>Total</UITable.HeaderCell>
          </UITable.Row>
        </UITable.Header>

        <UITable.Body>
          {getRow()}
          {getRow()}
          {getRow()}
          {getRow()}
          {getRow()}
          {getRow()}
        </UITable.Body>
      </UITable>

      <UITable.Footer>
        <UIPagination endPage={5} />
      </UITable.Footer>
    </Container>
  );
};

export default AnalyticsReporting;
